import config from "./config";

// 私有镜像列表查询
function queryUserImageApi(params) {
    return Ajax.get(config.queryUserImage, params);
}

//公共和定制镜像列表查询
function queryCommonImageApi(params) {
    return Ajax.get(config.queryCommonImage, params);
}

function deleteImageApi(params) {
	return Ajax.post(config.deleteImage, params, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
}

function describeImageSelectsApi(params) {
	return Ajax.get(config.describeImageSelects, params);
}

function exportImagesApi(params) {
	return Ajax.get(config.exportImages, params);
}

export { 
	queryUserImageApi,
	queryCommonImageApi,
	deleteImageApi,
	describeImageSelectsApi,
	exportImagesApi 
};



// WEBPACK FOOTER //
// ./src/api/mirror/list/actions.js